export default {"src":"/_next/static/media/_collections.cd7a17ef.svg","height":20,"width":20};